var ls = typeof localStorage === 'object' ? {
    set: function set(key, value) {
        try {
            value = JSON.stringify(value);
        } catch (err) {
            console.warn(err);
        }
        try {
            localStorage.setItem(key, value);
        } catch (err1) {
            console.warn(err1);
        }
    },
    get: function get(key) {
        var value;
        try {
            value = localStorage.getItem(key);
        } catch (err) {
            console.warn(err);
        }
        try {
            value = JSON.parse(value);
        } catch (err2) {
            console.warn(err2);
        }
        return value;
    },
    remove: function remove(key) {
        try {
            localStorage.removeItem(key);
        } catch (err) {
            console.warn(err);
        }
    }
} : {
    set: function set() {},
    get: function get() {},
    remove: function remove() {}
};
export default ls;
